import React from 'react';
import FAQBase from './FAQBase';

const questions = [
  {
    question: 'Can I avoid probate if I still have a mortgage?',
    answer:
      'Whether property can be transferred to a trust and how that may affect probate depends on factors such as state law, how the property is titled, and the terms of your loan.  In many cases, the mortgage remains in effect at death and must continue to be addressed according to its terms.',
  },
];

const RealEstateFAQ = () => <FAQBase questions={questions} />;

export default RealEstateFAQ;
